module.exports = __webpack_public_path__ + "banquet/components/InventoryRecordDetail/images/heart_filled.5c64e0ef0d02aa1de5a879ef9f0faabd.png";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/InventoryRecordDetail/images/heart_filled.png
// module id = 1669
// module chunks = 1